import { createReducer, on } from "@ngrx/store";
import { initialShelterSitesState } from "./shelter-sites.state";
import { setShelterSites, resetShelterSites } from "./shelter-sites.actions";
import * as _ from "lodash";

export const shelterSitesReducer = createReducer(
  initialShelterSitesState,
  on(setShelterSites, (state, { sites }) => ({
    ..._.cloneDeep(state),
    initialState: false,
    sites
  })),
  on(resetShelterSites, () => initialShelterSitesState)
);
